module.exports = __webpack_public_path__ + "img/res404.7b67dbb0.png";